<template>
	<section>
		<h2>WAT IS DE REDEN VAN DE SUPPORT TICKET?</h2>
		<div class="form-control">
			<select v-model="formData.reason">
				<option selected disabled value="">Reden van de ticket</option>
				<option v-for="reason in reasons" :key="reason" :value="reason">{{ reason }}</option>
			</select>
			<span v-if="formErrors.includes('reason')" class="form-error">Reden mag niet leeg zijn</span>
		</div>
		<div class="form-control">
			<textarea
				v-model="formData.description"
				rows="4"
				placeholder="Omschrijving van de support ticket"
			></textarea>
			<span v-if="formErrors.includes('description')" class="form-error">Omschrijving mag niet leeg
				zijn
			</span>
		</div>
		<div class="form-control">
			<div class="files">
				<div class="image-container" @click="$refs.uploadInput0 ? $refs.uploadInput0.click() : null">
					<loading-indicator
						v-if="pendingFile1 != null && pendingFile1.state === 'uploading'" class="loader"
					></loading-indicator>
					<img
						v-if="pendingFile1 != null"
						class="pending-upload"
						:src="pendingFile1.getThumbnail()"
					>
					<image-icon class="placeholder" v-if="pendingFile1 == null"></image-icon>
					<input
						class="upload-input"
						type="file"
						:multiple="false"
						@change="addFile($event.target.files, 0)"
						ref="uploadInput0"
						:accept="accept"
					>
				</div>
				<div class="image-container" @click="$refs.uploadInput1 ? $refs.uploadInput1.click() : null">
					<loading-indicator
						v-if="pendingFile2 != null && pendingFile2.state === 'uploading'" class="loader"
					></loading-indicator>
					<img
						v-if="pendingFile2 != null"
						class="pending-upload"
						:src="pendingFile2.getThumbnail()"
					>
					<image-icon class="placeholder" v-if="pendingFile1 == null"></image-icon>
					<input
						class="upload-input"
						type="file"
						:multiple="false"
						@change="addFile($event.target.files, 1)"
						ref="uploadInput1"
						:accept="accept"
					>
				</div>

			</div>
			<span v-if="formErrors.includes('files')" class="form-error">Foto's mogen niet leeg zijn</span>
		</div>
		<button type="button" @click="save">MAAK SUPPORT TICKET AAN</button>
	</section>
</template>

<script>

import {QueuedFile} from "@/common/queued-file";
import Button from "@/components/Button";
import LoadingIndicator from "@/components/LoadingIndicator";
import QuestionDynamicSelect from "@/components/QuestionDynamicSelect.vue";
import QuestionEmailInput from "@/components/QuestionEmailInput.vue";
import QuestionFileUpload from "@/components/QuestionFileUpload.vue";
import QuestionKmkInput from "@/components/QuestionKmkInput.vue";
import QuestionSignatureInput from "@/components/QuestionSignatureInput.vue";
import QuestionSingleFileUpload from "@/components/QuestionSingleFileUpload.vue";
import {client} from "@/store";
import {ArrowRightIcon, ChevronDownIcon, ChevronUpIcon, ImageIcon} from "vue-feather-icons";
import {mapState} from "vuex";

export default {

	components: {
		LoadingIndicator,
		ImageIcon
	},

	props: {
		projectId: Number,
		appointmentId: Number,
		companyId: Number
	},

	data() {
		return {
			formData: {
				reason: "",
				description: ""
			},
			formErrors: [],
			spouwisolatieReasons: [
				"Boorgaten vergeten te dichten",
				"Met verkeerde kleur gevoegd",
				"Troep achter gelaten",
				"Resten van het product zichtbaar",
				"Muur/kozijn ontzet",
				"Vochtplekken ontstaan",
				"Niet voldoende isolatiemateriaal aangebracht",
				"Schade aangebracht door hoogwerker",
				"Schade aangebracht door ons",
				"Nog ventilatieroosters plaatsen",
				"Anders"
			],
			reasons: [],
			pendingFile1: null,
			pendingFile2: null,
			accept: {
				type: String,
				default: "img/*"
			}
		};
	},

	beforeMount() {
	},

	mounted() {
		this.reasons = this.spouwisolatieReasons;
	},

	computed: {},

	methods: {
		addFile(files, index) {
			if (files.length > 0) {
				if (index === 0) {
					this.pendingFile1 = new QueuedFile(
						files[0],
						"support/afgebroken",
						this.companyId,
						this.$forceUpdate
					);
				} else {
					this.pendingFile2 = new QueuedFile(
						files[0],
						"support/afgebroken",
						this.companyId,
						this.$forceUpdate
					);
				}
				this.$forceUpdate();
			}
			this.$refs["uploadInput" + index].value = "";
		},

		save() {
			this.formErrors = [];
			if (this.empty(this.formData.reason) || this.empty(this.formData.description) || this.pendingFile1 == null || this.pendingFile2 == null) {
				if (this.empty(this.formData.reason)) {
					this.formErrors.push("reason");
				}
				if (this.empty(this.formData.description)) {
					this.formErrors.push("description");
				}
				if (this.pendingFile1 == null || this.pendingFile2 == null) {
					this.formErrors.push("files");
				}
				return;
			}
			Promise.all([this.pendingFile1.upload(), this.pendingFile2.upload()])
				.then(() => {
					this.performSave();
				})
				.catch((error) => {
					this.$notify({
						group: "app",
						title: "Opslaan mislukt",
						type: "error",
						text: `Er is een fout opgetreden bij het opslaan.`
					});
					console.error(error);
				});
		},

		performSave() {
			client.query(`mutation ($project_id: ID!, $appointment_id: ID!, $support_reason: String!, $description: String!, $invoice_on_hold: Boolean!, $send_photo_link: Boolean!, $email: String, $source: String!) {
					createSupportTicket(project_id: $project_id, appointment_id: $appointment_id, support_reason: $support_reason, description: $description, invoice_on_hold: $invoice_on_hold, send_photo_link: $send_photo_link, email: $email, source: $source)
				}`, {
				appointment_id: this.appointmentId,
				project_id: this.projectId,
				support_reason: this.formData.reason,
				description: this.formData.description,
				invoice_on_hold: false,
				email: null,
				send_photo_link: false,
				source: "Kwaliteitscontrole"
			}).then(result => {
				if(result.errors != null && result.errors.length > 0) {
					this.$notify({
						group: "app",
						title: "Opslaan mislukt",
						type: "error",
						text: `Er is een fout opgetreden bij het aanmaken van de support ticket.`
					});
					return;
				}

					this.$notify({
						group: "app",
						title: "Opslaan gelukt",
						type: "success",
						text: `De support ticket is aangemaakt.`
					});
					this.$router.push("/kwaliteit-afspraken");
			}).catch(error => {
				this.$notify({
					group: "app",
					title: "Opslaan mislukt",
					type: "error",
					text: `Er is een fout opgetreden bij het aanmaken van de support ticket.`
				});
			});
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		}

	}
};
</script>
<style lang="scss" scoped>

section {
	width: 100%;
}
.files {
	display: flex;
	flex-direction: row;
	gap: 16px;
}

.form-control {
	> input, > select, > textarea, ::v-deep > .DateField .DateField__group .TextField {
		border: 2px solid #ced6dd;
		border-radius: 5px;
		box-shadow: none;
		margin: 0 0 8px 0;
		padding: 0.5em;
		background: #ffffff;
		font-size: 1rem;
		width: 100%;
		box-sizing: border-box;
	}

	.form-error {
		color: #e53935;
	}
}

button {
	align-self: flex-end;
	margin: 8px 0 8px auto;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 5px 16px;
	background-color: #35a5a4;
	color: white;
	border: none;
	border-radius: 4px;
	font-weight: bold;
	height: 36px;
	width: 100%;
}

.image-container {
	aspect-ratio: 16/9;
	border: 2px solid #eeeeee;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	background: #ffffff;
	margin: 0 auto;
	width: 100%;

	.placeholder {
		height: 48px;
		width: 48px;
		color: #ced6dd;
	}

	label {
		font-size: 2rem;
	}

	.loader {
		z-index: 2;
		width: 50%;
		height: 50%;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}

	img {
		position: absolute;
		height: 100%;
		width: 100%;
		object-fit: cover;

		&.pending-upload {
			filter: contrast(0.5);
		}
	}

	input {
		display: none;
	}
}
</style>
